import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=33679bc8&scoped=true&"
import script from "./NewsCarousel.vue?vue&type=script&lang=js&"
export * from "./NewsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=33679bc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33679bc8",
  null
  
)

export default component.exports